export default "__VITE_ASSET__zP4ETP5g__"